// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2l_hC","buttons":"Footer_buttons__Kc92F"};